import { useMutation, useQuery } from '@tanstack/react-query'
import { apiClient } from '@/shared/api/client'

export interface DemoAgentInfo {
  agentAltKey: string
  agentName: string
  campaignName: string
  voiceName: string | null
  vapiAgentId: string | null
}

export interface DemoTokenResponse {
  token: string
  serverUrl: string
  roomName: string
  agentAltKey: string
  agentName: string
  participantIdentity: string
}

export interface DemoRoomDeleteResponse {
  roomName: string
  warning?: string
}

export function useDemoAgent(agentAltKey: string) {
  return useQuery({
    queryKey: ['demo-agent', agentAltKey],
    queryFn: () => apiClient<DemoAgentInfo>(`/demo/agent/${agentAltKey}`),
    enabled: !!agentAltKey,
    retry: false,
  })
}

export function useDemoToken() {
  return useMutation({
    mutationFn: (agentAltKey: string) =>
      apiClient<DemoTokenResponse>('/demo/token', {
        method: 'POST',
        body: JSON.stringify({ agentAltKey }),
      }),
  })
}

export function useDemoRoomDelete() {
  return useMutation({
    mutationFn: (roomName: string) =>
      apiClient<DemoRoomDeleteResponse>('/demo/room', {
        method: 'DELETE',
        body: JSON.stringify({ roomName }),
      }),
  })
}